<template>
  <div class="listpage">
    <div class="breadcrumb">
      <div class="content">
        <img class="homelogo" src="../assets/img/home.png">
        <span>当前位置： </span>
        <span>首页</span>
        >
        <span>竞价大厅</span>
      </div>
      <div>
        <input type="text" class="search2" v-model="keyword" @keyup.enter = "Query">
        <button class="searchbot2" @click="Query">
           <img style="height: 20px;margin-top: 6px;margin-left: 2px;" src="../assets/img/search.png" alt="">
        </button>
      </div>
    </div>
    <div class="z_detail">
            <div class="l_title">
                <h2 >竞价大厅</h2>
                <div class="tabs">
                  <span @click="QueryTabs(0)" :class="biddingType==0?'isactive':''">一次报价</span>
                  <!-- <span @click="QueryTabs(1)" :class="biddingType==1?'isactive':''">多次报价</span> -->
                  <!-- <span @click="QueryTabs(2)" :class="biddingType==2?'isactive':''">比选采购</span> -->
                  <span @click="QueryTabs(3)" :class="biddingType==3?'isactive':''">竞价采购结果</span>
                </div>
            </div>
            <div v-if="biddingType!=3">
              <div class="biddinglistbox">
                <div class="BiddingBox" v-for="(item,index) of biddingList" :key="index">
                <span @click="item.bulletinId==null?Bullet(item.prjId):BulletN(item.bulletinId)">
                <div class="BiddingType">
                  <span class="catalogue_span">
                    <span v-if="item.ztbTypeId==='0207'"  :class="'z-tag D02'"
                      >一次报价
                    </span>
                    <span v-if="item.ztbTypeId==='0208'"   :class="'z-tag D01'"
                      >多次报价
                    </span>
                    <span v-if="item.ztbTypeId==='0210'"  :class="'z-tag D03'"
                      >比选采购
                    </span>
                  </span>
                  </div>
                <div class="BiddingTitle">{{item.prjName}}</div>
                <div class="BiddingSTitle">采购单位：<span>{{item.yzCompanyName}}</span></div>
                <div class="BiddingSTitle">预算价格：<span class="price">{{item.basePrice}}元</span></div>
                <div class="BiddingSTitle">品目分类：<span>{{item.callingName}}</span></div>
                <div class="BiddingSTitle">项目编号：<span>{{item.prjNo}}</span></div>
                </span>
                <div class="BiddingTime">
                  <span>
                    <img style="height: 23px;width: 23px;" src="../assets/img/BiddingBell.png">
                    <span v-if="!getcountdown(item.kbDate).showcountdown||item.state==4">
                      报价结束
                    </span>
                    <span v-else-if="item.state==6">
                      已暂停
                    </span>
                    <span v-else>距报价结束
                      <span>
                      {{getcountdown(item.kbDate).days}}天
                      {{getcountdown(item.kbDate).hours}}时
                      {{getcountdown(item.kbDate).minutes}}分
                      </span>
                    </span>
                  </span>
                  <!-- <button @click="Bidding(item.prjId)" :disabled="!getcountdown(item.kbDate).showcountdown||item.state==4">
                    立即报价
                  </button> -->
                  <button v-if="getcountdown(item.kbDate).showcountdown&&item.state!=='4'" @click="Bidding(item.prjId)">
                    立即报价
                  </button>
                </div>
                </div>
              </div>
            </div>
            <div v-else class="lista">
                <ul>
                    <li v-for="(item,index) of biddingResult" :key="index">
                        <div class="listtitle">
                          <router-link :to="'/detail??type=10&prjId='+item.prjId" >{{item.prjName}}</router-link>
                        </div>
                        <div>{{GetDate(item.closeDate)}}</div>
                    </li>
                </ul>
            </div>
            <div class="pagination">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="current"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
    </div>
  </div>
</template>

<script>
import { GetPurchaseResults, GetBiddingHall } from '@/api/Home'
import moment from 'moment'
export default {
  data () {
    return {
      biddingType: 0,
      biddingList: [],
      biddingResult: [],
      current: 1,
      pageSize: 12,
      total: 0,
      keyword: ''
    }
  },
  computed: {
    btngroupbid () {
      var Array = [
        { key: 1, name: '一次报价', active: true, biddingType: 0 },
        { key: 2, name: '多次报价', active: false, biddingType: 1 },
        { key: 3, name: '比选采购', active: false, biddingType: 2 },
        { key: 4, name: '竞价采购结果', active: false, biddingType: 3 }
      ]
      let _biddingType = Number(this.$route.query.biddingType)
      Array.forEach((item) => {
        item.active = false
        if (item.biddingType === _biddingType) {
          item.active = true
        }
      })
      return Array
    }
  },
  methods: {
    GetList () {
      if (this.biddingType !== 3) {
        let param = {}
        param.pageIndex = this.current
        param.pageSize = this.pageSize
        param.classID = '22'
        if (this.biddingType === 0) {
          param.ztbTypeId = '0207'
        } else if (this.biddingType === 1) {
          param.ztbTypeId = '0208'
        } else if (this.biddingType === 2) {
          param.ztbTypeId = '0210'
        }
        this.biddingList = []
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total
          this.biddingList = res.data.projectList
        })
      } else {
        let _param = {}
        _param.pageIndex = this.current
        _param.pageSize = this.pageSize
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total
          this.biddingResult = res.data
        })
      }
    },
    Query () {
      if (this.biddingType !== 3) {
        let param = {}
        param.pageIndex = this.current
        param.pageSize = this.pageSize
        param.classID = '22'
        param.keywords = this.keyword
        param.deptId = this.deptId

        if (this.biddingType === 0) {
          param.ztbTypeId = '0207'
        } else if (this.biddingType === 1) {
          param.ztbTypeId = '0208'
        } else if (this.biddingType === 2) {
          param.ztbTypeId = '0210'
        }
        this.biddingList = []
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total
          this.biddingList = res.data.projectList
        })
      } else {
        let _param = {}
        _param.pageIndex = this.current
        _param.pageSize = this.pageSize
        _param.keywords = this.keyword
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total
          this.biddingResult = res.data
        })
      }
    },
    QueryTabs (tab) {
      this.keyword = ''
      this.biddingType = tab
      this.Query()
    },
    handleCurrentChange (page) {
      this.current = page
      if (this.biddingType !== 3) {
        let param = {}
        param.pageIndex = this.current
        param.pageSize = this.pageSize
        param.keywords = this.keyword
        param.classID = '22'
        if (this.biddingType === 0) {
          param.ztbTypeId = '0207'
        } else if (this.biddingType === 1) {
          param.ztbTypeId = '0208'
        } else if (this.biddingType === 2) {
          param.ztbTypeId = '0210'
        }
        this.biddingList = []
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total
          this.biddingList = res.data.projectList
        })
      } else {
        let _param = {}
        _param.pageIndex = this.current
        _param.pageSize = this.pageSize
        _param.keywords = this.keyword
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total
          this.biddingResult = res.data
        })
      }
    },
    getcountdown (kbDate) {
      //
      var date = moment(kbDate)
      var now = moment()
      let start = moment(new Date())
      let end = moment(new Date(kbDate))
      let result = {
        showcountdown: false
      }
      if (now < date) {
        let diff = end.diff(start)
        let days = moment.duration(diff).days()
        let hours = moment.duration(diff).hours()
        let minutes = moment.duration(diff).minutes()
        result.days = days > 9 ? days : '0' + days
        result.hours = hours
        result.minutes = minutes
        result.showcountdown = true
        return result
      } else {
        return result
      }
    },
    Bidding (prjId) {
      window.open('/wstb/login.html?PrjId=' + prjId, '_blank')
    },
    GetDate (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10)
      }
      return day
    },
    Bullet (prjId) {
      this.$router.push({
        path: '/detail',
        query: { type: 1, prjId: prjId }
      })
    },
    BulletN (bulletinId) {
      this.$router.push({
        path: '/detail',
        query: { bulletinId: bulletinId }
      })
    }
  },
  mounted () {
    this.GetList()
  }
}
</script>

<style scoped>
.l_title{
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
  height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.pagination{
  text-align: right;
  margin-top: 25px;
}
.biddinglistbox{
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.BiddingBox{
  margin-right: 75px;
}
.BiddingBox:nth-child(3n){
  margin-right: 0;
}
.tabs{
  display: flex;
  /* position: absolute; */
  right: 183px;
  margin-top: -42px;
  float: right;
}
.tabs>span{
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border: 1px solid #e4e7ed;
  font-size: 14px;
  border-right: 0px;
  cursor: pointer;
  width: 85px;
  text-align: center;
}
.tabs>span:nth-child(4){
  border-right: 1px solid #e4e7ed;
}
.isactive{
  border-bottom: 1px solid #FFFFFF!important;
  color: #409eff;
  font-weight: 600;
}
.lista{
  min-height: 266px;
}
.lista ul{
    list-style-type: none;
    padding: 0;
}
.lista li{
    width: 100%;
    border-bottom: 1px solid #e8e8e8;
    padding: 8px 0;
    display: flex;
    justify-content: space-around;
}
.lista li>div{
    line-height: 21px;
    height: 21px;
}
.listtitle{
    width: calc(100% - 150px);
    text-align: left;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
.listtitle a{
    color: black;
    text-decoration: none;
}
.listtitle a:hover{
    color: #4e4e4e;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/biddinglist.vue